import environmentConfig from "configuration/environmentConfig";
import { IntegrationTypes } from "../types";
import "./tooltipsHelpers.scss";

const helpCenterLink = environmentConfig.helpCenterUrl;
const helpCenterRelativeUrls = environmentConfig.helpCenterRelativeUrls;

const syncUsersHelpCenterLinks: Partial<{ [key in IntegrationTypes]: string }> = {
  [IntegrationTypes.Google]: `${helpCenterLink}/${helpCenterRelativeUrls.googleIntegrationRelativeUrl}`,
  [IntegrationTypes.MsGraph]: `${helpCenterLink}/${helpCenterRelativeUrls.microsoftGraphIntegrationRelativeUrl}`,
  [IntegrationTypes.Webex]: `${helpCenterLink}/${helpCenterRelativeUrls.integrationsRelativeUrl}`,
};

export const getSyncUsersTooltipMessage = (integrationType: string) => {
  const integration = integrationType as IntegrationTypes;
  const supportLink = syncUsersHelpCenterLinks[integration];
  return (
    <>
      {integration === IntegrationTypes.MsGraph
        ? "Sync only those with a license in your account, "
        : "Sync all users "}
      from this integration. For more details, visit our{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        Help Center.
      </a>
    </>
  );
};

const importUsageHelpCenterLinks: Partial<{ [key in IntegrationTypes]: string }> = {
  [IntegrationTypes.Google]: `${helpCenterLink}/${helpCenterRelativeUrls.googleIntegrationRelativeUrl}`,
  [IntegrationTypes.MsGraph]: `${helpCenterLink}/${helpCenterRelativeUrls.microsoftGraphIntegrationRelativeUrl}`,
  [IntegrationTypes.Webex]: `${helpCenterLink}/${helpCenterRelativeUrls.integrationsRelativeUrl}`,
};

export const getImportUsageDataTooltipMessage = (integrationType: string) => {
  const supportLink = importUsageHelpCenterLinks[integrationType as IntegrationTypes];
  return (
    <>
      Activate this option to include application usage data. For more details, visit our{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        Help Center.
      </a>
    </>
  );
};

export const getImportLicensesTooltipMessage = () => {
  const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.microsoftGraphIntegrationDataRelativeUrl}`;
  return (
    <>
      Enable this option to include Microsoft licensing data and enable automatic group enrollment based on license
      type. For more details, visit our{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        Help Center.
      </a>
    </>
  );
};

export const getImportGroupsTooltipMessage = () => {
  const supportLink = `${helpCenterLink}/${helpCenterRelativeUrls.microsoftGraphIntegrationDataRelativeUrl}`;
  return (
    <>
      Enable this option to include Microsoft group data and enable automatic group enrollment based on Graph groups.
      For more details, visit our{" "}
      <a className="tooltip-link" href={supportLink} target="_blank" rel="noreferrer">
        Help Center.
      </a>
    </>
  );
};

export const ruleCombineTypeTooltipMessage =
  'All filters with the same rule will be handled as an "Or" statement. This selection controls how different rules work together.';
